import {
  Criteria,
  NestedQuota,
  QuotaPayload,
} from '../../shared/interfaces/quota.interface';
import { SurveyNestedQuotas } from './survey-nested-quotas';
import { SurveyQuotaCriterion } from './survey-quota-criterion';

export class UnNestedQuotaFilter {
  constructor(
    private readonly _quotas: QuotaPayload[],
    private readonly _nestedQuotas: NestedQuota[]
  ) {}

  private get _ungroupedNestedQuotas(): NestedQuota[] {
    return new SurveyNestedQuotas(this._nestedQuotas).ungrouped().get();
  }

  public quotas(): QuotaPayload[] {
    return this._quotas.filter((q) => !this._matches(q.criteria));
  }

  private _matches(criteria: Criteria[]): boolean {
    return criteria.some((quotaCriterion) => {
      if (new SurveyQuotaCriterion(quotaCriterion).isRange()) {
        return this._rangeMatches(quotaCriterion);
      }

      return this._conditionMatches(quotaCriterion);
    });
  }

  private _rangeMatches(quotaCriterion: Criteria): boolean {
    return this._ungroupedNestedQuotas.some((nq) =>
      nq.criteria
        .filter((nqCriterion) =>
          new SurveyQuotaCriterion(nqCriterion).isRange()
        )
        .some(
          (nqCriterion) =>
            new SurveyQuotaCriterion(nqCriterion).qualificationCode() ===
              new SurveyQuotaCriterion(quotaCriterion).qualificationCode() &&
            new SurveyQuotaCriterion(quotaCriterion).range()[0].from! >=
              new SurveyQuotaCriterion(nqCriterion).range()[0].from! &&
            new SurveyQuotaCriterion(quotaCriterion).range()[0].to! <=
              new SurveyQuotaCriterion(nqCriterion).range()[0].to!
        )
    );
  }

  private _conditionMatches(quotaCriterion: Criteria): boolean {
    return this._ungroupedNestedQuotas.some((nq) =>
      nq.criteria
        .filter(
          (nqCriterion) => !new SurveyQuotaCriterion(nqCriterion).isRange()
        )
        .some(
          (nqCriterion) =>
            new SurveyQuotaCriterion(nqCriterion).qualificationCode() ===
              new SurveyQuotaCriterion(quotaCriterion).qualificationCode() &&
            new SurveyQuotaCriterion(quotaCriterion)
              .conditions()
              .every((c) =>
                new SurveyQuotaCriterion(nqCriterion).conditions().includes(c)
              )
        )
    );
  }
}
